/** @jsx jsx */
// External libraries
import { jsx } from '@emotion/core';
import { useEffect } from 'react';
import { useStoreState } from 'easy-peasy';

// Internal modules
import { Main } from '../Main';
import { Footer } from '../Footer';
import { Header } from '../Header';
import { fetchInitialData } from './api';
import { useMountLogging } from '@/lib';
import { appSectionStyles, appStyles } from './styles';
import {
  checkFrameBust,
  handleBlockedDomesticTransactions,
  handleSignupAndGuestIneligible,
  logIncontext,
} from './utils';
import {
  EmotionWrapper,
  MerchantLogo,
  PageLoadingSpinner,
  PayPalValueProps,
} from './Components';
import { conditionallyCalculateShippingAndTaxes } from '@/components/Shipping/utils';

const App = () => {
  useMountLogging('App');
  useEffect(() => {
    // We should generally refrain from adding more checks in here as it's not
    // scalable and bug prone to introduce complex logic at the start of the App
    handleBlockedDomesticTransactions();
    handleSignupAndGuestIneligible();
  });
  useEffect(() => {
    checkFrameBust();
    logIncontext();
    fetchInitialData().then(() => {
      conditionallyCalculateShippingAndTaxes();
    });
  }, []);

  const isPageLoading = useStoreState(state => state.ui.isPageLoading);
  if (isPageLoading) {
    return (
      <EmotionWrapper>
        <PageLoadingSpinner />
      </EmotionWrapper>
    );
  }

  return (
    <EmotionWrapper>
      <div css={appStyles}>
        <MerchantLogo />
        <div css={appSectionStyles}>
          <Header />
          <Main />
          <Footer />
        </div>
        <PayPalValueProps />
      </div>
    </EmotionWrapper>
  );
};

export { App };
